const MS_PER_DAY = 86_400_000;

/** "2026-09-08" -> "8. 9. 2026" */
export function formatDate(iso) {
  if (!iso) return '';
  const [y, m, d] = iso.split('-').map(Number);
  if (!y || !m || !d) return iso;
  return `${d}. ${m}. ${y}`;
}

/** "2026-09-08" -> "8. září" (bez roku, pro kompaktní výpisy) */
export function formatDayMonth(iso) {
  if (!iso) return '';
  const [y, m, d] = iso.split('-').map(Number);
  if (!y || !m || !d) return iso;
  return new Intl.DateTimeFormat('cs-CZ', { day: 'numeric', month: 'long' }).format(new Date(y, m - 1, d));
}

const startOfToday = () => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate());
};

/** Počet celých dní od dneška k datu (záporné = v minulosti). */
export function daysUntil(iso) {
  if (!iso) return null;
  const [y, m, d] = iso.split('-').map(Number);
  if (!y || !m || !d) return null;
  return Math.round((new Date(y, m - 1, d) - startOfToday()) / MS_PER_DAY);
}

const plural = (n, one, few, many) => (n === 1 ? one : n >= 2 && n <= 4 ? few : many);

/**
 * Stav deadlinu pro štítek u úkolu.
 * V archivovaném ročníku stav nepočítáme – tam už je „po termínu“ jen šum.
 */
export function deadlineStatus(iso, { archived = false } = {}) {
  const days = daysUntil(iso);
  if (days === null) return { tone: 'quiet', label: 'Bez termínu', past: false };
  if (archived) return { tone: 'quiet', label: formatDate(iso), past: true };

  if (days < 0) {
    const n = Math.abs(days);
    return { tone: 'quiet', label: `Po termínu (${n} ${plural(n, 'den', 'dny', 'dní')})`, past: true };
  }
  if (days === 0) return { tone: 'danger', label: 'Odevzdat dnes', past: false };
  if (days === 1) return { tone: 'danger', label: 'Zbývá 1 den', past: false };
  if (days <= 7) return { tone: 'warn', label: `Zbývá ${days} ${plural(days, 'den', 'dny', 'dní')}`, past: false };
  return { tone: 'ok', label: `Zbývá ${days} dní`, past: false };
}

/** "5 bodů" se správným tvarem */
export function formatPoints(points) {
  return `${points} ${plural(points, 'bod', 'body', 'bodů')}`;
}
